import { render, staticRenderFns } from "./TradeSellOfferView.vue?vue&type=template&id=27335f38&scoped=true&"
import script from "./TradeSellOfferView.vue?vue&type=script&lang=ts&"
export * from "./TradeSellOfferView.vue?vue&type=script&lang=ts&"
import style0 from "./TradeSellOfferView.vue?vue&type=style&index=0&id=27335f38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27335f38",
  null
  
)

export default component.exports